import { render, staticRenderFns } from "./routingService.vue?vue&type=template&id=6ce1c790&scoped=true&"
import script from "./routingService.vue?vue&type=script&lang=js&"
export * from "./routingService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce1c790",
  null
  
)

export default component.exports